import { Translate } from '@travel/translation';
import DomesticErrorPage from '@travel/traveler-core/components/DomesticErrorPage';
import FaqLink from '@travel/traveler-core/components/DomesticErrorPage/FaqLink';
import { useTranslation } from '@travel/traveler-core/hooks';
import { Link } from '@travel/ui';

import type { ResolutionType } from '@travel/traveler-core/components/DomesticErrorPage';

const ERROR_PAGE_LABELS = {
  errorTitleLabel: 'Review_Common.Error_Message.Application_Error.Fatal.Title',
  followingMethodsLabel:
    'Review_Common.Error_Message.Application_Error.Fatal.Navigation.Description',
  helpPagesReferenceLabel: 'Review_Common.Error_Message.Application_Error.Fatal.Help.Description',
  helpTopPageReferenceLabel:
    'Review_Common.Error_Message.Application_Error.Fatal.Help.Help_top.Text',
  helpTopPageTextLabel:
    'Review_Common.Error_Message.Application_Error.Fatal.Help.Help_top.HyperLink_Text',
  helpTopPageLinkLabel:
    'Review_Common.Error_Message.Application_Error.Fatal.Help.Help_top.HyperLink_URL',
} as const;

const RESOLUTION_LIST_LABELS = [
  'Review_Common.Error_Message.Application_Error.Fatal.Navigation.Item1.Text',
  'Review_Common.Error_Message.Application_Error.Fatal.Navigation.Item2.Text',
] as const;

const HELP_LIST_LABELS = [
  {
    text: 'Review_Common.Error_Message.Application_Error.Fatal.Help.Item1.Text',
    url: 'Review_Common.Error_Message.Application_Error.Fatal.Help.Item1.URL',
  },
  {
    text: 'Review_Common.Error_Message.Application_Error.Fatal.Help.Item2.Text',
    url: 'Review_Common.Error_Message.Application_Error.Fatal.Help.Item2.URL',
  },
  {
    text: 'Review_Common.Error_Message.Application_Error.Fatal.Help.Item3.Text',
    url: 'Review_Common.Error_Message.Application_Error.Fatal.Help.Item3.URL',
  },
] as const;

function ErrorPage() {
  const helpTopPageUrl = useTranslation({ id: ERROR_PAGE_LABELS.helpTopPageLinkLabel });

  const resolutionList: ResolutionType[] = RESOLUTION_LIST_LABELS.map((resolution) => {
    return {
      id: resolution,
      label: <Translate id={resolution} key={resolution} />,
    };
  });

  return (
    <DomesticErrorPage
      commonLabelId={ERROR_PAGE_LABELS}
      resolutionList={resolutionList}
      helpList={HELP_LIST_LABELS.map((faqItem) => {
        return <FaqLink key={faqItem.text} textLabelId={faqItem.text} urlLabelId={faqItem.url} />;
      })}
      helpTopPageLabel={
        <Translate
          id={ERROR_PAGE_LABELS.helpTopPageReferenceLabel}
          data={{
            help_top: (
              <Link
                url={helpTopPageUrl}
                label={<Translate id={ERROR_PAGE_LABELS.helpTopPageTextLabel} />}
                haveUnderline
              />
            ),
          }}
        />
      }
    />
  );
}

export default ErrorPage;
